// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { locationFinderStyles } from "@steiner/Overrides/Widgets/LocationFinder/LocationFinder";
import { css } from "styled-components";

locationFinderStyles.topColumnGridItem = {
    width: 12,
};

locationFinderStyles.leftColumnGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    order: 2;
                `,
                css`
                    order: 2;
                `,
                css`
                    order: 2;
                `,
                null,
                null,
            ])}
    `,
};

locationFinderStyles.rightColumnGridItem = {
    width: [12, 12, 12, 8, 8],
};
